module.exports = __webpack_public_path__ + "fatih atlas mutfak.jpg?2e26709610640f0e56855d156ba5d786";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fatih atlas mutfak.jpg
// module id = 133
// module chunks = 0